import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import './userstable.css';

const UsersTable = () => {
    const [users, setUsers] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: ''
    });

    const fetchUsers = async () => {
        const { data, error } = await supabase
            .from('users')
            .select('*')
            .order('id', { ascending: false });

        console.log("FETCH USERS ERROR:", error);

        if (error) {
            alert(error.message);
            return;
        }

        setUsers(data || []);
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const addUser = async (e) => {
        e.preventDefault();

        const { data, error } = await supabase
            .from('users')
            .insert([
                {
                    name: form.name,
                    email: form.email,
                    phone: form.phone
                }
            ])
            .select();

        console.log("INSERT DATA:", data);
        console.log("INSERT ERROR:", error);

        if (error) {
            alert(error.message);
            return;
        }

        setForm({ name: '', email: '', phone: '' });
        setShowForm(false);
        fetchUsers();
    };

    const deleteUser = async (id) => {
        const confirmDelete = window.confirm("Delete this user?");
        if (!confirmDelete) return;

        const { error } = await supabase
            .from('users')
            .delete()
            .eq('id', id);

        if (error) {
            alert(error.message);
            return;
        }

        setUsers(prev => prev.filter(u => u.id !== id));
    };

    const editUser = async (user) => {
        const newName = window.prompt("Edit name", user.name);
        const newEmail = window.prompt("Edit email", user.email);
        const newPhone = window.prompt("Edit phone", user.phone);

        if (!newName || !newEmail || !newPhone) return;

        const { error } = await supabase
            .from('users')
            .update({
                name: newName,
                email: newEmail,
                phone: newPhone
            })
            .eq('id', user.id);

        if (error) {
            alert(error.message);
            return;
        }

        fetchUsers();
    };

    return (
        <div className="userstable">

            <div className="etopbar">
                <h6 className="tabletitle">Users</h6>

                <button
                    className="addeventbt"
                    onClick={() => setShowForm(true)}
                    type="button"
                >
                    <div className="plus"></div>
                    <span className="bttext">Add user</span>
                </button>
            </div>

            <div className="tableheader">
                <p>Name</p>
                <p>Email</p>
                <p>Phone</p>
                <p>Actions</p>
            </div>

            {users.map((user) => (
                <div className="tablerrow" key={user.id}>
                    <p>{user.name}</p>
                    <p>{user.email}</p>
                    <p>{user.phone}</p>

                    <div className="actions">
                        <button onClick={() => editUser(user)}>Edit</button>
                        <button onClick={() => deleteUser(user.id)}>Delete</button>
                    </div>
                </div>
            ))}

            {showForm && (
                <div className="modalOverlay">
                    <div className="modal">
                        <h3>Add User</h3>

                        <form onSubmit={addUser}>
                            <input
                                placeholder="Name"
                                value={form.name}
                                onChange={(e) =>
                                    setForm({ ...form, name: e.target.value })
                                }
                            />

                            <input
                                placeholder="Email"
                                value={form.email}
                                onChange={(e) =>
                                    setForm({ ...form, email: e.target.value })
                                }
                            />

                            <input
                                placeholder="Phone"
                                value={form.phone}
                                onChange={(e) =>
                                    setForm({ ...form, phone: e.target.value })
                                }
                            />

                            <div className="modalActions">
                                <button type="submit" className="modalActionsadd">
                                    Add
                                </button>

                                <button
                                    type="button"
                                    className="modalActionscancel"
                                    onClick={() => setShowForm(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
};

export default UsersTable;